/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListNotificationsQueryResponse,
  ListNotificationsQueryParams,
} from '../types/ListNotifications'

function getListNotificationsUrl() {
  const res = { method: 'GET', url: `/api/v1/notifications/` as const }
  return res
}

/**
 * @summary List the 5 most recent notifications for the current user
 * {@link /api/v1/notifications/}
 */
export async function listNotifications(
  params?: ListNotificationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListNotificationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListNotificationsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
